import axios from 'axios';

/**
 * Same-origin publication proxy for Instagram feed (avoids CORS + hides API URL details).
 */
export function getInstagramFeed({ limit = 9, cursor = null } = {}) {
  const websiteId =
    window.OPTIONS_INIT_SITE &&
    window.OPTIONS_INIT_SITE.options &&
    window.OPTIONS_INIT_SITE.options.w_code
      ? window.OPTIONS_INIT_SITE.options.w_code
      : '';

  const params = {
    website_id: websiteId,
    limit,
  };

  if (cursor) {
    params.cursor = cursor;
  }

  return axios.get('/cheetah/instagram/feed', { params });
}
